import { List, Map } from "immutable";
import _ from "lodash";

import { ITEM_CARD_SEQUENCE_LIST_VIEW, TIMELINE_VIEW, TUTORIAL_PANEL } from "../../../constants/identifiers";
import OPEN_VIEWS_MODES from "../../../constants/openViewsModes";
import { MOBILE_LANDSCAPE_VIEW_TYPES, MOBILE_PORTRAIT_VIEW_TYPES } from "../../../constants/viewTypes";
import { definitionActionTypes } from "../../definition";
import { actionTypes } from "../actions";
import { getOpenViewsReducer } from "./openViews";
import { getExpandedItemKeyForMobile } from "./utils";

let desktopOpenViews = getOpenViewsReducer(OPEN_VIEWS_MODES.desktop);
let tabletOpenViews = getOpenViewsReducer(OPEN_VIEWS_MODES.tablet);
let mobileLandscapeOpenViews = getOpenViewsReducer(OPEN_VIEWS_MODES.mobileLandscape);

const scrollingIsLocked = (state = true, action) => {
  switch (action.type) {
    case actionTypes.LOCK_SCROLLING:
      return true;
    case actionTypes.UNLOCK_SCROLLING:
      return false;
    default:
      return state;
  }
};

const makeUnique = list => List(_.uniq(list.toArray()));

const leftPanelWidth = (state, action) => {
  switch (action.type) {
    case actionTypes.SET_LEFT_PANEL_WIDTH:
      return action.width;
    case actionTypes.SET_PANEL_WIDTHS:
      return action.left;
    default:
      return state;
  }
};

const mobileView = (state, action, prevGlobalState) => {
  switch (action.type) {
    // #!if mobile === true || harvard === true
    case actionTypes.SET_LEFT_PANEL_MODE:
      return action.mode === TUTORIAL_PANEL ? state.set("portraitViewType", action.mode) : state;
    case actionTypes.SWITCH_MOBILE_PORTRAIT_VIEW_TYPE:
      return state.set("portraitViewType", action.viewType);
    case actionTypes.SWITCH_MOBILE_LANDSCAPE_VIEW_TYPE:
      return state.set("landscapeViewType", action.viewType);
    case actionTypes.TOGGLE_EXPAND_SUPER_ITEM_MOBILE_LIST:
      return state.updateIn([getExpandedItemKeyForMobile(prevGlobalState)], expanded => {
        let newExpanded = expanded;
        action.itemIds.forEach(id => {
          newExpanded = action.isExpanded
            ? newExpanded.contains(action.typeId)
              ? newExpanded
              : newExpanded.push(id)
            : newExpanded.filter(t => t !== id);
        });
        return newExpanded;
      });
    // #!endif
    case actionTypes.HIDE_MOBILE_LEFT_PANEL: {
      const result = state.withMutations(sm => {
        sm.update("portraitViewType", t =>
          !MOBILE_PORTRAIT_VIEW_TYPES.includes(t) ? ITEM_CARD_SEQUENCE_LIST_VIEW : t
        );
        sm.update("landscapeViewType", t => (!MOBILE_LANDSCAPE_VIEW_TYPES.includes(t) ? TIMELINE_VIEW : t));
      });
      return result;
    }
    default:
      return state;
  }
};

const expandedFilterGroups = (state = Map(), action) => {
  switch (action.type) {
    case actionTypes.COLLAPSE_FILTER_GROUP:
      return state.update(action.filterId, groups => (groups ? groups.filter(g => g !== action.groupId) : List()));
    case actionTypes.EXPAND_FILTER_GROUP:
      return state.update(action.filterId, groups => (groups ? groups.push(action.groupId) : List([action.groupId])));
    case definitionActionTypes.REPLACE_DEFINITIONS: {
      return action.definitions.includeNarrative ? state : state.map(groups => groups.filter(g => g !== "narrative"));
    }
    default:
      return state;
  }
};

const expandedEntityItems = (state = Map(), action) => {
  switch (action.type) {
    case actionTypes.TOGGLE_ENTITY_LIST_ITEM: {
      const expandedItemIds = (state.get(action.entityType) || List()).filter(id => !action.itemIds.includes(id));
      let newState = state.set(
        action.entityType,
        action.isExpanding ? expandedItemIds.concat(action.itemIds) : expandedItemIds
      );
      return newState;
    }
    default:
      return state;
  }
};

const excludeSearchTypes = (state = List(), action) => {
  switch (action.type) {
    case actionTypes.CHANGE_SEARCH_FOR_TYPE: {
      return action.value ? state.filter(t => t !== action.typeId) : state.push(action.typeId);
    }
    default:
      return state;
  }
};

const fontPercentage = (state = 100, action) => {
  switch (action.type) {
    case actionTypes.SET_FONT_PERCENTAGE:
      return action.percentage;
    default:
      return state;
  }
};

const exposedFilterTypes = (state, action) => {
  switch (action.type) {
    case actionTypes.ADD_EXPOSED_FILTER_TYPE:
      return action.filterType && !state.includes(action.filterType) ? state.push(action.filterType) : state;
    case actionTypes.REMOVE_EXPOSED_FILTER_TYPE:
      return action.filterType ? state.filter(f => f !== action.filterType) : state;
    case definitionActionTypes.REPLACE_DEFINITIONS:
      return action.definitions.includeNarrative ? state : state.filter(f => f !== "narrative");
    default:
      return state;
  }
};

export {
  desktopOpenViews,
  excludeSearchTypes,
  expandedEntityItems,
  expandedFilterGroups,
  exposedFilterTypes,
  fontPercentage,
  leftPanelWidth,
  makeUnique,
  mobileLandscapeOpenViews,
  mobileView,
  scrollingIsLocked,
  tabletOpenViews
};
